import React from 'react';

const IllustrationOmniumXL: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="65"
      fill="none"
      viewBox="0 0 68 65"
    >
      <rect width="65" height="65" x="1.263" fill="#F3F1F5" rx="22"></rect>
      <path
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.39"
        d="M38.816 32.54l6.688-5.265h-4.3l2.389-8.616-7.644 5.744L30.218 11l-1.91 14.36-5.733-2.393 6.21 9.095"
      ></path>
      <path
        fill="#6F558A"
        d="M21.879 17.949a1.39 1.39 0 100-2.78 1.39 1.39 0 000 2.78zM51.758 28.372a1.39 1.39 0 100-2.78 1.39 1.39 0 000 2.78zM20.142 30.456a1.042 1.042 0 100-2.084 1.042 1.042 0 000 2.084zM38.903 15.169a1.042 1.042 0 100-2.084 1.042 1.042 0 000 2.084z"
      ></path>
      <path
        stroke="#D5CCDF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M3 51.877h62.82"
      ></path>
      <path
        fill="#E2DBE9"
        d="M39.012 47.653c.252.225.578.348.914.346H66l.642-21.739-8.911-.368a1.357 1.357 0 00-1.192.61l-5.594 8.487-12.199.718a1.358 1.358 0 00-1.224.972c-.053.178-.07.365-.049.55l1.09 9.552c.037.336.197.647.45.872z"
      ></path>
      <path
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M66.642 26.26l-8.911-.368a1.357 1.357 0 00-1.192.61l-5.594 8.487-12.199.718a1.358 1.358 0 00-1.224.972c-.053.178-.07.365-.049.55l1.09 9.552c.037.336.197.647.45.872.25.225.577.348.913.346H66"
      ></path>
      <path
        fill="#E2DBE9"
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M46.723 51.944c-2.462 0-4.457-2.004-4.457-4.476s1.995-4.476 4.457-4.476c2.461 0 4.457 2.004 4.457 4.476s-1.996 4.476-4.457 4.476z"
      ></path>
      <path
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M46.723 51.944c-2.462 0-4.457-2.004-4.457-4.476s1.995-4.477 4.457-4.477c2.461 0 4.457 2.005 4.457 4.477 0 2.472-1.996 4.476-4.457 4.476z"
      ></path>
      <path
        fill="#6F558A"
        d="M46.723 49.483a2.01 2.01 0 01-2.007-2.015 2.01 2.01 0 012.007-2.015 2.01 2.01 0 012.006 2.015 2.01 2.01 0 01-2.006 2.015z"
      ></path>
      <path
        fill="#fff"
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M38.016 41.724h2.608a.544.544 0 00.546-.547v-2.19a.549.549 0 00-.546-.548h-2.982l.373 3.285zM64.689 29.132h-6.747a.643.643 0 00-.342.096.587.587 0 00-.227.259l-2.385 5.343a.546.546 0 00.055.542c.056.08.132.144.221.19.09.044.189.068.29.068h9.135v-6.498z"
      ></path>
      <path
        fill="#E2DBE9"
        d="M28.63 47.653a1.36 1.36 0 01-.914.346H1.642L1 26.26l8.912-.368a1.358 1.358 0 011.19.61l5.595 8.487 12.2.718a1.359 1.359 0 011.223.972c.054.178.07.365.05.55l-1.091 9.552a1.371 1.371 0 01-.449.872z"
      ></path>
      <path
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M1 26.26l8.912-.368a1.358 1.358 0 011.19.61l5.595 8.487 12.2.718a1.359 1.359 0 011.223.972c.054.178.07.365.05.55l-1.091 9.552a1.371 1.371 0 01-.449.872 1.36 1.36 0 01-.914.346H1.642"
      ></path>
      <path
        fill="#E2DBE9"
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M20.92 51.944c2.461 0 4.457-2.004 4.457-4.476s-1.996-4.476-4.457-4.476c-2.462 0-4.458 2.004-4.458 4.476s1.996 4.476 4.458 4.476z"
      ></path>
      <path
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M20.92 51.944c2.461 0 4.457-2.004 4.457-4.476S23.38 42.99 20.92 42.99c-2.462 0-4.458 2.005-4.458 4.477 0 2.472 1.996 4.476 4.458 4.476z"
      ></path>
      <path
        fill="#6F558A"
        d="M20.92 49.483a2.01 2.01 0 002.006-2.015 2.01 2.01 0 00-2.006-2.015 2.01 2.01 0 00-2.007 2.015 2.01 2.01 0 002.007 2.015z"
      ></path>
      <path
        fill="#fff"
        stroke="#6F558A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.625"
        d="M29.627 41.724h-2.609a.544.544 0 01-.545-.547v-2.19a.549.549 0 01.545-.548H30l-.373 3.285zM2.954 29.132H9.7c.121 0 .24.033.342.096.1.063.18.153.227.259l2.384 5.343a.546.546 0 01-.055.542.603.603 0 01-.221.19.648.648 0 01-.29.068H2.954v-6.498z"
      ></path>
      <path
        fill="#3297FD"
        d="M57.5 19a9.5 9.5 0 100-19 9.5 9.5 0 000 19z"
      ></path>
      <path
        fill="#fff"
        d="M57.938 6.11l-2.177 3.405 2.207 3.376h-1.842l-1.33-2.207-1.33 2.207h-1.783L53.846 9.5l-2.192-3.39h1.812l1.345 2.206 1.33-2.207h1.797zM63.317 12.89h-4.385V6.11h1.462v5.334h2.923v1.447z"
      ></path>
    </svg>
  );
};

export default IllustrationOmniumXL;
